<template>
    <div style="padding: 16px; background: lightgray;">

        <div style="background:white; padding: 8px; direction:rtl; max-width: 600px; margin: auto; border-radius: 5px; box-shadow: 0 2px 8px rgba(0, 0, 0, .33)">

            <div style="position: relative;display: inline-block; width: 100%; margin-bottom: 16px;">
                <img src="https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2Flong%20screen.png?alt=media&token=2762a85f-89fd-448f-a913-146df1651060"
                     style="width: 100%; border-radius: 5px; box-shadow: 0 2px 8px rgba(0, 0, 0, .33)"/>

            </div>

            <div style="font-size: 24px; box-shadow: 0 2px 8px rgba(0, 0, 0, .33); margin-bottom: 16px; font-weight: bold; border-radius: 5px; text-align: center; background: #501078; color:white; padding: 16px;">
                קיבלתם ביקורת חדשה!
            </div>


            <!-- body -->
            <table style="margin-bottom: 16px">

                <!-- quest name -->
                <tr >
                    <td style="font-weight: bold; ">שם הקווסט</td>
                    <td >טרוול קווסט מסביב לעולם</td>
                </tr>

                <!-- player name -->
                <tr >
                    <td style="font-weight: bold; ">שם השחקן</td>
                    <td > שלומי שלומי</td>
                </tr>

                <!-- email -->
                <tr >
                    <td style="font-weight: bold; ">אימייל השחקן</td>
                    <td >dan@travelAndQuest.com</td>
                </tr>

                <br>

                <!--overall rating -->
                <tr >
                    <td style="font-weight: bold; ">דירוג כללי</td>
                    <td >1\5</td>
                </tr>

                <!--diff level -->
                <tr >
                    <td style="font-weight: bold; ">דרגת קושי</td>
                    <td >3\5</td>
                </tr>

                <!-- public review-->
                <tr >
                    <td style="font-weight: bold; ">ביקורת פומבית</td>
                    <td > לא אהבנו את את המשחק הזה והזה וכו...</td>
                </tr>

                <!-- private review-->
                <tr >
                    <td style="font-weight: bold; ">ביקורת פרטית</td>
                    <td > לא אהבנו את את המשחק הזה והזה וכו...</td>
                </tr>

            </table>



            <div style="color: #D2222D; margin-bottom: 16px; font-size: 14px;" >
                <div>
                    *במקרה של ביקורת עם ספוילר, הנכם מוזמנים ליצור עימנו קשר במייל ל- dan@travelAndQuest.com תוך ציון מפורש של הספוילר בביקורת והדגשת המילים הבעייתיות.
                </div>
                <div>
                    צוות התוכן שלנו יבדוק את הנושא ויתיחס תוך כ-24 שעות.
                </div>
            </div>

            <div style="font-size: 20px; margin-bottom: 8px; box-shadow: 0 2px 8px rgba(0, 0, 0, .33); border-radius: 5px;  background: #501078; padding: 4px;" >
            </div>

            <div style="font-weight: bold; color: #501078; margin-top: 16px" >
                <div >
                    בברכה,
                </div>
                <div>
                    צוות טרוול קווסט
                </div>
            </div>
        </div>

        <div style="text-align: center; margin: auto; margin-top: 16px;">

            <a href="https://www.instagram.com/travelandquest/" target="_blank">
                <img style="background: #E1306C; padding: 8px; margin: 8px;  border-radius: 8px; box-shadow: 0 2px 8px rgba(0, 0, 0, .33)" width="32px"
                     src="https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2Finstegram.png?alt=media&token=eae34265-2718-4aa8-b522-c17f06cd6b83"/>
            </a>

            <a href="https://www.facebook.com/TravelAndQuest" target="_blank">
                <img style="background: #3C5A99; padding: 8px; margin: 8px;  border-radius: 8px; box-shadow: 0 2px 8px rgba(0, 0, 0, .33)" width="32px"
                     src="https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2Ffacebook.png?alt=media&token=40609b40-7afe-444c-813f-9ebf5afdff87"/>
            </a>

            <a href="https://travelquest.xyz" target="_blank">
                <img style="background: #753679; margin: 8px; border-radius: 8px; box-shadow: 0 2px 8px rgba(0, 0, 0, .33)" width="48px"
                     src="https://firebasestorage.googleapis.com/v0/b/travelquest-da6b2.appspot.com/o/TQ%2Flogofull2.png?alt=media&token=53def682-011a-459a-91c9-100bf179409a"/>
            </a>
        </div>

    </div>
</template>

<script>
    export default {
        name: "v_Email_Review",
    }
</script>

<style scoped>
</style>